module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hans_1-3a7e25914a54c91bdce7a06c4b030ff3.jpg";